export default {
    path:'/order',
    redirect: {name:'investOrder'},
    component:() => import('@/pages/s'),
    children:[
      // 投资订单
      {
        path:'investOrder',
        name:'investOrder',
        component:() => import('@/pages/order/investOrder')
      },
      //借款订单
      {
        path:'loanOrder',
        name:'loanOrder',
        component:() => import('@/pages/order/loanOrder')
      }
    ]
  }